import * as yaml from 'js-yaml';

export type ApiDefinitionKind =
  | 'openapi'
  | 'asyncapi'
  | 'unknown'
  | 'empty'
  | 'invalid';

export interface ApiDefinitionParseResult {
  kind: ApiDefinitionKind;
  document?: unknown;
  language?: 'json' | 'yaml';
  error?: string;
}

const detectApiKind = (document: unknown): ApiDefinitionKind => {
  if (!document || typeof document !== 'object') {
    return 'unknown';
  }

  const candidate = document as Record<string, unknown>;
  if (candidate.asyncapi) {
    return 'asyncapi';
  }
  if (candidate.openapi || candidate.swagger) {
    return 'openapi';
  }
  return 'unknown';
};

export const parseApiDefinition = (
  definition: string | undefined,
): ApiDefinitionParseResult => {
  if (!definition?.trim()) {
    return { kind: 'empty' };
  }

  try {
    const document = JSON.parse(definition);
    return {
      kind: detectApiKind(document),
      document,
      language: 'json',
    };
  } catch {
    try {
      const document = yaml.load(definition);
      return {
        kind: detectApiKind(document),
        document,
        language: 'yaml',
      };
    } catch (error) {
      return {
        kind: 'invalid',
        language: 'yaml',
        error:
          error instanceof Error ? error.message : 'Invalid API definition',
      };
    }
  }
};
